import * as React from 'react';
import * as autoBind from 'react-autobind';
import Strings from '../../globals/Strings';
import EventHandlingModalContainer from '../EventHandlingModal/EventHandlingModalContainer';
import {TscButtonType} from '@techsmith/tsc-cloud-style-guide';

export default class ChangeReviewByDateNotificationsModal extends React.Component<ChangeReviewByDateNotificationsModalProps, {}> {
   constructor(props: ChangeReviewByDateNotificationsModalProps) {
      super(props);
      autoBind(this);
   }

   render() {
      return (
         <EventHandlingModalContainer visible={true} defaultOnClose={this.props.onClose} title={Strings.labels.deadlineChanged} closeContent={Strings.labels.close} confirmContent={Strings.labels.emailReviewers} confirmButtonType={TscButtonType.primary} dismissContent={Strings.labels.dontSendReviewers} >
            {Strings.labels.confirmDeadlineChangedNotifications}
         </EventHandlingModalContainer>
      );
   }
}

interface ChangeReviewByDateNotificationsModalProps {
   onClose(): void;
}
